<template>
    <van-popup
        v-model="popupFreightServer"
        position='bottom'
        closeable
        close-icon="close"
        @close='onClose'
        :round='true'
        :style="{ height: '60%', background: '#ffff' }"
    >
        <div class="popup">
            <Server />
        </div>
    </van-popup>
</template>

<script>
import Server from './Server'
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Server
    },
    methods: {
        onClose () {
            this.$emit('update:visible')
        }
    },
    computed: {
        // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
        popupFreightServer: {
            get () {
                return this.visible
            },
            set () {
                this.$emit('update:visible')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.popup {
    background: #ffffff;
}
/deep/ .van-popup {
    background: #ffffff;
}
/deep/ .van-popup__close-icon {
    font-size: 50px;
    right: 32px;
    top: 32px;
}
</style>